var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[(_vm.settings)?_c('iframe',{ref:"vc-iframe",staticStyle:{"height":"50vh","border":"1px #d8d7d6 solid"},attrs:{"type":"text/html","allow":"microphone; camera","width":"100%","src":_vm.settings.vMaatuSettings.serverAdd +
          '?api_key=' +
          _vm.settings.vMaatuSettings.apiKey +
          '&room_name=' +
          _vm.requestedAhc._id}}):_vm._e(),_c('chat',{attrs:{"to":_vm.requestedAhc.careCoordinator,"appointment-id":_vm.requestedAhc._id}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }